<script>
/* Imports */
    import BlokNacitani from './../BlokNacitani.svelte';
    import DateInput from "./TerminovyKalendar/DateInput.svelte";
    import KalendarHeader from "./TerminovyKalendar/KalendarHeader.svelte";
    import KalendarMesic from "./TerminovyKalendar/KalendarMesic.svelte";
    import { APIrequestGET } from '../js_libs/API_calls';

/* Props */
    export let VybraneRezervaceZakaznika = [];
    export let ChybovyVyber = false; 

    export let ResplaceUUID = "";

/* Vlastnosti */
    // Vybírané datumy pro začátek a konec rezervací
    let VybraneDatum = new Date(new Date().setDate(new Date().getDate() + 1));

    // Dovoluje měsícům mezi sebou komunikovat o momentálním typu vybíraného data uživatelem
    let PrepinacVyberuData = 0;


    // Zobrazení uživatele
    let PocetZobrazovanychMesicu = 3;
    let PocatecniDatumZobrazeni = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
    
    
    // Údržba dostupných rezervací v paměti 
    let PocetMesicuVPameti = PocetZobrazovanychMesicu;
    let PocatecniDatumDat = PocatecniDatumZobrazeni;
    $: KonecneDatumDat = ZiskatKonecneDatumDatVPameti(PocetMesicuVPameti);
    
    
    let AktualniZiskaneRezervacniTerminy = [];
    
    $: PocatekZobrazovanychMesicu = (PocatecniDatumZobrazeni) =>
    {
        
        return PocatecniDatumZobrazeni.getMonth() - PocatecniDatumDat.getMonth() + ((PocatecniDatumZobrazeni.getFullYear() - PocatecniDatumDat.getFullYear()) * 12);
    }

    $: KonecZobrazovanychMesicu = (PocatecniDatumZobrazeni) =>
    {
        return PocatecniDatumZobrazeni.getMonth() - PocatecniDatumDat.getMonth() + ((PocatecniDatumZobrazeni.getFullYear() - PocatecniDatumDat.getFullYear()) * 12) + PocetZobrazovanychMesicu;
    }
/* Funkce */

    /**
     * 
     */
    function AktualizujUzivateluvVyber()
    {
        // console.log("POC", VybraneDatum);
        // console.log("END", VybraneKoncoveDatum);

        console.log("AktualizujUzivateluvVyber", VybraneDatum);

        let filtrovanePrvky = AktualniZiskaneRezervacniTerminy.filter(prvek => 
        {
            const start = new Date(prvek.start_time).getTime();
            // console.log("STR", new Date(prvek.start_time));
            return (start >= VybraneDatum.getTime() && start <= VybraneDatum.getTime()) || (JsouDataStejna(new Date(start), VybraneDatum));
        });

        let errorable = filtrovanePrvky.some(prvek => prvek.reserved === prvek.capacity) || (new Date(VybraneDatum.toDateString())) < new Date(new Date().toDateString());
        if (errorable)
        {
            VybraneRezervaceZakaznika = [];
            ChybovyVyber = true;
        }
        else 
        {
            VybraneRezervaceZakaznika = filtrovanePrvky;
            ChybovyVyber = false;
        }

        console.log("AktualizujUzivateluvVyberEnd", VybraneDatum);
    }

    /**
     * Získá konečné datum, pro stažení ze serveru.
     * 
     * @param {Number} rozsah - počet měsíců v řadě po datu zobrazení.
     */
    function ZiskatKonecneDatumDatVPameti(rozsah) 
    {
        const pocatek = PocatecniDatumDat;

        return new Date(pocatek.getFullYear(), pocatek.getMonth() + rozsah, 0);
    }

    /**
     * Vybere měsíce pro zobrazení v kalendáři
     * 
     * @param ZobrazovanyMesic (Date) - počáteční datum zobrazení kalendáře
     * @param PocetMesicu (Number) - počet měsíců, které se mají zobrazit od počátečního data
     * @returns {Array<Array>} - pole měsíců, které se mají zobrazit - pole obsahuje pouze prvky Date prvního dne daného měsíce
     */
    function ZiskatMesice(RezervacniTerminy) {
        // console.log(RezervacniTerminy);

        // Zápis dat pro vybírané funkce
        AktualniZiskaneRezervacniTerminy = RezervacniTerminy;

        const mesiceMapa = new Map();

        RezervacniTerminy.forEach(termin => {
            const datum = new Date(termin.start_time);
            const klic = `${datum.getFullYear()}-${datum.getMonth()}`; // např. "2025-5"

            if (!mesiceMapa.has(klic)) {
                mesiceMapa.set(klic, []);
            }

            mesiceMapa.get(klic).push(termin);
        });

        // Zajistí, že všechny měsíce mezi PocatecniDatumDat a KonecneDatumDat budou obsaženy
        const d = new Date(PocatecniDatumDat.getFullYear(), PocatecniDatumDat.getMonth(), 1);
        const konec = new Date(KonecneDatumDat.getFullYear(), KonecneDatumDat.getMonth(), 1);

        while (d <= konec) {
            const rok = d.getFullYear();
            const mesic = d.getMonth();
            const klic = `${rok}-${mesic}`;

            if (!mesiceMapa.has(klic)) {
                const placeholder = {
                    start_time: `${rok}-${String(mesic + 1).padStart(2, '0')}-01 00:00:00`,
                    end_time: `${rok}-${String(mesic + 1).padStart(2, '0')}-01 00:30:00`,
                    available: false,
                    reserved_count: 0,
                    capacity: 0
                };
                mesiceMapa.set(klic, [placeholder]);
            }

            d.setMonth(mesic + 1);
        }

        // Seřadit podle roku a měsíce
        const serazene = Array.from(mesiceMapa.entries()).sort(([a], [b]) => {
            const [rokA, mesicA] = a.split('-').map(Number);
            const [rokB, mesicB] = b.split('-').map(Number);
            return rokA !== rokB ? rokA - rokB : mesicA - mesicB;
        });

        // console.log(serazene.map(([_, terminy]) => terminy));

        // Vrátit jen pole s termíny
        return serazene.map(([_, terminy]) => terminy);
    }


    /**
     * @description Formátuje datum pro API v požadovaném formátu DD-MM-YYYY
     * 
     * @param {Date} datum - Datum, které se má formátovat pro API
     * 
     * @returns {String} - Formátované datum ve tvaru DD-MM-YYYY
     */
    function FormatovatDatumProAPI(datum) 
    {
        const dd = String(datum.getDate()).padStart(2, '0');
        const mm = String(datum.getMonth() + 1).padStart(2, '0');
        const yyyy = datum.getFullYear();
        const final = `${yyyy}-${mm}-${dd}`;
        // console.log("Formátované datum pro API:", final);

        return final;
    }

    /**
     * Získá informace o kapacitách, termínech ze serveru.
     * 
     * @param prvniDen - Počátek výběru termínů k rezervaci
     * @param posledniDen - Konec výběru termínů k rezervaci
     * 
     * @return {Promise<Object>} s možnými termíny rezervace pro daný měsíc
     */
    async function ZiskatTerminyRezervaci(prvniDen, posledniDen)
    {
        const PrvniDen = new Date(prvniDen.getFullYear(), prvniDen.getMonth(), prvniDen.getDate());
        const PosledniDen = new Date(posledniDen.getFullYear(), posledniDen.getMonth(), posledniDen.getDate());

        return JSON.parse(await APIrequestGET(
            "available",
            {
                "res_place_uuid" : ResplaceUUID,
                "dateFrom" : FormatovatDatumProAPI(PrvniDen),
                "dateTo" : FormatovatDatumProAPI(PosledniDen)
            }
        ))
    }

    /**
     * @description Funkce vypočítá, zda je rok, měsíc a den u obou datumů stejný
     * 
     * @param {Date} date1 - první datum k porovnání
     * @param {Date} date2 - druhé datum k porovnání
     * 
     * @returns {Bool} true, pokud je rok, měsíc a den stejný u dvou dat
     */
    function JsouDataStejna(date1, date2) 
    {
        return date1.getFullYear() === date2.getFullYear() &&
            date1.getMonth() === date2.getMonth() &&
            date1.getDate() === date2.getDate();
    }
</script>

<div 
    class="terminovy-kalendar"
    style="width: 100%; display: flex; flex-direction: column; align-items: center;"
    >

    <label style="width: 100%; text-align: center;" for="kalendar-od-do">Vyberte termín (den a <strong>čas příchodu na proceduru</strong>)</label>
    
    <div class="kalendar-od-do" name="kalendar-od-do">
        <div class="kalendar-inputs">
            <DateInput 
                id="pocatecni-datum"
                labelTitle=""
                required={true}
                styleInside="border-radius: 9999px; padding: 1rem 3rem;"
                bind:date={VybraneDatum}
                on:change={() => {
                    // if(VybraneDatum.getTime() > KonecneDatumDat.getTime())
                    // {
                    //     KonecneDatumDat = new Date(VybraneDatum.getFullYear(), VybraneDatum.getMonth() + 1, 0);
                    // }

                    // AktualizujUzivateluvVyber();
                }}
            />
        </div>
        <KalendarHeader
            bind:PocatecniDatumZobrazeni
            bind:PocetZobrazovanychMesicu
            on:posunMesiceVpred={()=>
                {
                    if(KonecZobrazovanychMesicu(PocatecniDatumZobrazeni) > PocetMesicuVPameti)
                    {
                        PocetMesicuVPameti++;
                    }
                }
            }
            />
        <div class="kalendar-mesice">
            {#await ZiskatTerminyRezervaci(PocatecniDatumDat, KonecneDatumDat)}
                <BlokNacitani height={"295px"} />
            {:then terminy} 
                {#each ZiskatMesice(terminy) as mesic, i}
                    <KalendarMesic
                        TerminyProDanyMesic={mesic}
                        bind:VybraneDatum
                        bind:PrepinacVyberuData
                        displayed={i >= PocatekZobrazovanychMesicu(PocatecniDatumZobrazeni) && i < KonecZobrazovanychMesicu(PocatecniDatumZobrazeni)}
                        on:change={() => {
                            // AktualizujUzivateluvVyber();
                            //displayed={i >= PocetMesicuVPameti - PocetZobrazovanychMesicu && i < PocetMesicuVPameti}
                        }}
                        />
                {/each}
                
            {/await}
        </div>
        <div class="terminy-hodiny">
            {#if AktualniZiskaneRezervacniTerminy.filter((item) => {
                const startDate = new Date(VybraneDatum.getTime() - (VybraneDatum.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];
                return item.start_time.startsWith(startDate);
            }).length <= 0} 
                <label style="width: 100%; text-align: center; margin-top: 1rem;" for="terminy-hodiny"><strong>Vyberte čas příchodu na proceduru </strong></label>
                <p style="color:red; margin-top: 0.5rem;">Ve vybraný den ({VybraneDatum.toLocaleDateString('cs-CZ')}) nejsou k dispozici žádné termíny rezervace.</p>
            {:else}
                <label style="width: 100%; text-align: center; margin-top: 1rem;" for="terminy-hodiny"><strong>Vyberte čas příchodu na proceduru </strong></label>
            {/if}
            {#each AktualniZiskaneRezervacniTerminy.filter((item) => {
                
                const startDate = new Date(VybraneDatum.getTime() - (VybraneDatum.getTimezoneOffset() * 60000 )).toISOString().split("T")[0];
                return item.start_time.startsWith(startDate);
            }) as termin_hodin, i}
                <button 
                    class:selected={VybraneRezervaceZakaznika.some(r => r.start_time == termin_hodin.start_time)}
                    class:notBookable={(termin_hodin.capacity == termin_hodin.reserved_count) || ((new Date(termin_hodin?.start_time).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)))}
                    disabled={(termin_hodin.capacity == termin_hodin.reserved_count) || ((new Date(termin_hodin?.start_time).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0)))}
                    on:click|preventDefault={() => {
                        if (!(
                            (termin_hodin.capacity == termin_hodin.reserved_count) || 
                            (new Date(termin_hodin?.start_time).setHours(0, 0, 0, 0) <= new Date().setHours(0, 0, 0, 0))
                        )) {
                            VybraneRezervaceZakaznika = [
                                ...VybraneRezervaceZakaznika,
                                termin_hodin
                            ].filter(
                                (rez, index, self) =>
                                    index === self.findIndex(r => r.start_time === rez.start_time)
                            );
                        }
                    }
                }> 
                    {termin_hodin.start_time.split(" ")[1].slice(0, 5)}
                </button>
            {/each}
        </div>
    </div>
</div>  



<style>
    .kalendar-od-do 
    {
        /* max-width: 900px; */
        margin: 0 auto;
        font-family: Arial, sans-serif;
        width: 100%;
    }
    .kalendar-inputs
    {
        display: flex;
        gap: 2em;
        margin: 1em 0 1em 0;
        justify-content: space-evenly;
    }
    .kalendar-mesice 
    {
        display: flex;
        gap: 2em;
    }
    div.terminy-hodiny {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 1rem;
        justify-content: center;
        align-items: center;
        margin: 1rem 0 1rem 0;
    }

    div.terminy-hodiny > button:nth-last-child(-n + 3) {
        display: none;
    }
    
    .selected 
    {
        background: #1976d2 !important;
        color: #fff;
        border-color: #1976d2;
        border: 1px solid #1976d2 !important;
    }

    .notBookable 
    {
        background: #df6b6b !important;
        color: #ededed;
        border-color: #df6b6b !important;
        border: 1px solid #df6b6b !important;
    }

    button:disabled 
    {
        background: #eee;
        color: #ededed;
        cursor: not-allowed;
    }

    button 
    {
        background-color: limegreen !important;
        /* -webkit-font-smoothing: antialiased;
        text-rendering: optimizeLegibility;
        list-style-type: none!important;
        box-sizing: border-box;
        text-transform: uppercase;
        font-size: 16px;
        cursor: pointer;
        position: relative;
        line-height: 1 !important;
        font-style: normal !important;
        vertical-align: middle;
        transition: .3s;
        text-shadow: none!important;
        font-family: Lato,Helvetica,Arial,sans-serif;
        text-align: center;
        font-weight: 700;
        text-decoration: none!important;
        display: block;
        letter-spacing: 0;
        color: #fff !important;
        border: 1px solid #bc9321;
        outline: 0;
        padding: 0.7em 1.5em;
        box-shadow: none !important;
        border-color: #bc9321;
        background: #bc9321;
        border-radius: 99em; */
    }

    
    button:hover 
    {
        /* color: rgb(188, 147, 33) !important;
        background: none !important;
        border-color: rgb(188, 147, 33) !important; */
    }
</style>